<div class="d-block">
    @if (collectionSize() > pageSize()) {
        <ngb-pagination
            class="d-flex justify-content-center mb-3 mb-md-2 pagination-mobile"
            [page]="currentPage()"
            [collectionSize]="collectionSize()"
            [disabled]="disabled()"
            [maxSize]="responsiveMaxSize()"
            [pageSize]="pageSize()"
            [rotate]="true"
            (pageChange)="onPageChange($event)"></ngb-pagination>
    }

    <div
        class="d-flex align-items-center justify-content-between justify-content-sm-center flex-wrap gap-2">
        @if (showTotal()) {
            <span class="fw-bold me-md-3"
                >{{ collectionSize() }}
                {{ 'pagination_RESULTS' | translate: 'common' : 'brunata-angular-ui' }}</span
            >
        }
        <div class="d-flex align-items-center">
            <label for="selectPageSize" class="col-form-label text-nowrap me-2 me-md-3">{{
                'pagination_RESULTS_PER_PAGE' | translate: 'common' : 'brunata-angular-ui'
            }}</label>
            @if (customSelect()) {
                <div
                    ngbDropdown
                    display="dynamic"
                    placement="top-start top-end bottom-start bottom-end">
                    <button
                        type="button"
                        class="btn btn-outline-primary d-flex align-items-center gap-2"
                        style="min-width: 5rem"
                        ngbDropdownToggle>
                        {{ pageSize() }}
                        <span
                            class="icon-chevron-down"
                            style="width: 1.25rem; height: 1.25rem"></span>
                    </button>
                    <div ngbDropdownMenu>
                        @for (value of pageSizeOptions; track value) {
                            <button
                                ngbDropdownItem
                                [class.active]="pageSize() === value"
                                (click)="pageSizeControl.setValue(value)">
                                {{ value }}
                            </button>
                        }
                    </div>
                </div>
            } @else {
                <select
                    (change)="onPageChange(1)"
                    [formControl]="pageSizeControl"
                    id="selectPageSize"
                    style="max-width: 5rem"
                    class="form-select d-inline-block">
                    @for (value of pageSizeOptions; track value) {
                        <option [ngValue]="value">{{ value }}</option>
                    }
                </select>
            }
        </div>
    </div>
</div>
